import React from 'react'

import { useDroppable } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { DataItem } from 'scrivito'

import { KanbanItem } from './KanbanColumnItem'

interface KanbanBodyProps {
  id: string
  items: DataItem[]
  schema: DataItem
  onOpenItemDrawer: (item: DataItem) => void
}

export const KanbanBody: React.FC<KanbanBodyProps> = ({
  id,
  items,
  schema,
  onOpenItemDrawer,
}) => {
  const { setNodeRef } = useDroppable({
    id,
  })

  return (
    <SortableContext
      id={id}
      items={items.map((e) => e.id())}
      strategy={verticalListSortingStrategy}
    >
      <div className="list-kanban-body">
        <div className="list-kanban-items" ref={setNodeRef}>
          {items.map((e) => (
            <KanbanItem
              key={e.id()}
              item={e}
              schema={schema}
              onOpenItemDrawer={onOpenItemDrawer}
            />
          ))}
        </div>
      </div>
    </SortableContext>
  )
}
